<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import Card from '@/components(new)/UI/Cards/Card/Card.vue'

export default {
  components: {
    TitleWithRow,
    InputSelect,
    Label,
    Card
  },

  props: {
    nomeAba: {
      default: 'ILPF/FLoresta'
    },
    especiesFlorestais: {
      type: Array,
      required: true
    },
    pratica: {
      required: true
    }
  },

  data () {
    return {
      especie: {
        especie: '',
        produtividade: '',
        outrasEspecies: ''
      }
    }
  },

  computed: {
    disableButton () {
      return !(
        this.especie.especie &&
        this.especie.produtividade &&
        ((this.containsOption(this.especie.especie, 'OUTROS', 'outrasEspecies') && this.especie.outrasEspecies) || !this.containsOption(this.especie.especie, 'OUTROS', 'outrasEspecies'))
      )
    }
  },
  methods: {
    containsOption (parent, option, model) {
      let contains
      if (!Array.isArray(parent)) {
        contains = parent === option
      } else {
        contains = parent.includes(option)
      }
      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.especie)
        if (target && lastProp) {
          target[lastProp] = null
        }
      }
      return contains
    },
    btnAdicionar () {
      this.pratica.florestas.push({
        ...this.especie
      })
      this.especie = {
        especie: '',
        produtividade: '',
        outrasEspecies: ''
      }
    },
    btnApagar (index) {
      this.pratica.florestas.splice(index, 1)
    },

    btnEditar (floresta, index) {
      this.especie = {
        especie: floresta.especie,
        produtividade: floresta.produtividade,
        outrasEspecies: floresta.outrasEspecies
      }
      this.btnApagar(index)
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Espécies florestais utilizadas e produtividade" />
    <el-row :gutter="20">
      <InputSelect
        :label="'Espécies florestais'"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :rulesInput="!pratica.florestas.length ? 'required' : ''"
        :opcoes="especiesFlorestais"
        v-model="especie.especie"
        :widthColumn="8"
      />

      <validation-provider :rules="!pratica.florestas.length ? 'required' : ''" v-slot="{ errors }" :name="nomeAba + '/Qual espécie '">
        <el-col :span="8" v-if="containsOption(especie.especie, 'OUTROS', 'outrasEspecies')">
          <Label label="Qual espécie?" :obrigatorio="true" />
          <el-input
            v-model="especie.outrasEspecies"
            style="width: 100%"
            clearable
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>

      <validation-provider :rules="!pratica.florestas.length ? 'required' : ''" v-slot="{ errors }" :name="nomeAba + '/Produtividade '">
        <el-col :span="8">
          <Label label="Produtividade" :obrigatorio="true" />
          <el-input
            v-model="especie.produtividade"
            placeholder="Ex: 20 x 20"
            style="width: 100%"
            clearable
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>

    <el-row style="width: 100%; top: 20px; display: flex; justify-content: flex-end;">
      <el-button
        :disabled="disableButton"
        round type="primary"
        @click="btnAdicionar()"
      >
        Adicionar
      </el-button>
    </el-row>
    <div style="display: flex; flex-wrap: wrap;">
      <div v-for="(l, i) in pratica.florestas" :key="i+l.especie">
        <Card
          :objeto="{
            ...l,
            especie: pratica.florestas ? especiesFlorestais.find(floresta => floresta.id === l.especie).nome : '-'
          }"
          :deletar="() => btnApagar(i)"
          :editar="() => btnEditar(l, i)"
          titulo="Espécies florestais"
        />
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/ILPF/IlpfFloresta.vue